<div class="item">
  <mat-card appearance="outlined" id="item_{{ node().data.id }}"
    [style.background-color]="generateColorFromString(node().data.type.toLowerCase())" [draggable]="!node().data.in_trash">
    <mat-card-header (click)="expandCurrentItem(node().data.id)" class="card-header">
      <div class="flex-container">
        <span class="title-in-header" matTooltip="{{ node().data.title }}">{{ node().data.title | textLimit:30 }}</span>
        @if(isChildrenExist(node())) {
        <span class="num-children-string"
          matTooltip="This item has {{node()?.children.length}} {{node()?.children.length > 1 ? 'sub-items' : 'sub-item'}}">
          ({{node()?.children.length}})
        </span>
        }
        @if(isShared()) {
        <mat-icon class="group-icon"
          matTooltip="This item is shared with {{getPermissionsDisplayText(node().data.shared_with)}}">group</mat-icon>
        }
  
        <span class="status-in-header" [ngClass]=" itemStatusString ? status[itemStatusString] : 'hidden' " matTooltip="Status: {{ node().data.status }}">{{
          node().data.status
          }}</span>
  
        <span class="priority-in-header" [ngClass]=" itemPriorityString ? priority[itemPriorityString] : 'hidden' " matTooltip="Priority: {{ node().data.priority }}">{{ node().data.priority }}</span>

        @for (tag of node().data.tags; track $index) {
        <span class="tag-in-header" matTooltip="Tag: {{ tag }}">#{{ tag }}</span>
        }

        @if(node().data.size) {
        <span class="size-in-header" matTooltip="Size: {{ node().data.size }}">{{ node().data.size }}</span>
        }
        
        @if(isExpanded()){
        <mat-icon class="arrange-expand-icon">keyboard_arrow_up</mat-icon>
        } @else {
        <mat-icon class="arrange-expand-icon">keyboard_arrow_down</mat-icon>
        }
      </div>
    </mat-card-header>
    <mat-card-content [@toggleContainer]="isExpanded() ? 'expand' : 'collapse'" class="mat-container">
      <div class="item-details">
        <!--Basic Info-->
        <div class="item-properties-container">
          <div class="item-properties-left">
            <span class="item-attribute"><span class="title">Full Title:</span>{{ node().data.title }} </span>
            <span class="item-attribute"><span class="id">Id:</span>{{ node().data.id }} </span>
            <span class="item-attribute"><span class="type">Type:</span>{{ node().data.type }}</span>
            
            <div class="item-attribute">
              <span class="shared-with">Shared with:</span>
              <span>{{ getPermissionsDisplayText(node().data.shared_with) }}</span>
            </div>
            <div class="item-attribute">
              <span class="subscribers">Subscriber(s):</span>
              <span>{{ getDisplayText(node().data.subscribers) }}</span>
            </div>
            <div class="item-attribute">
              <span class="tags">Tags:</span>
              @for (tag of node().data.tags; track $index) {
              <span class="tag">#{{ tag }}</span>
              }
            </div>
          </div>
          <div class="item-properties-right">
            <span class="item-attribute"><span class="status">Status:</span>{{ node().data.status }}</span>
            <span class="item-attribute"><span class="priority">Priority:</span>{{ node().data.priority }}</span>
            <div class="item-attribute">
              <span class="assignees">Assignee(s):</span>
              <span>{{ getDisplayText(node().data.assignees) }}</span>
            </div>
            <span class="item-attribute"><span class="size">Size:</span>{{ node().data.size }}</span>
            <div class="item-attribute">
              <span class="start-date">Start Date:</span>
              <span>{{ node().data?.start_date | dateFormat:'dddd, MMMM D, YYYY' }}</span>
            </div>
            <div class="item-attribute">
              <span class="due-date">Due Date:</span>
              <span>{{ node().data?.due_date | dateFormat:'dddd, MMMM D, YYYY' }}</span>
            </div>
          </div>
        </div>
        <!--Description-->
        <div class="item-attribute">
          <span class="description-label">Description:</span>
          @if(node().data.description) {
          <span class="description-content">{{ node().data.description }}</span>
          }
        </div>
        <!--Attachments-->
        <div class="item-attribute">
          <span class="attachment-label">Attachments:</span>
          <div class="attachment-wrapper">
            <app-thumbnail [attachments]="attachments" [hideRemoveButton]="true"/>
          </div>
        </div>
        <mat-divider></mat-divider>
        <!--History-->
        <div class="item-attribute">
          <span class="history-header">History:</span>
          <ul class="history-content">
            @for (record of node().data.history; track $index) {
            <li class="history-record" [hidden]="$index >= NO_OF_EVENTS_IN_RECENT_HISTORY && !isHistoryExpanded()">
              <div>
                <span>{{ generateHistoryRecordText(record).date }}</span>
                <span [innerHTML]="generateHistoryRecordText(record).text| highlightText: types"></span>
              </div>
            </li>
            }
            <a class="show-history-link" [hidden]="!additionalHistoryHidden()" (click)="showHideFullHistory(node().data.id)">{{
              isHistoryExpanded() ? 'Less' : 'More' }}</a>
          </ul>
        </div>
      </div>
      @if (node().data.in_trash) {
      <div class="move-from-trash-button-wrapper">
        <button mat-mini-fab (click)="moveFromTrashButtonAction()" matTooltip="Undelete">
          <mat-icon>restore</mat-icon>
        </button>
      </div>
      } @else {
      <div class="edit-button-wrapper">
        <button mat-mini-fab (click)="editItemButtonAction($event)" matTooltip="Edit">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      }
    </mat-card-content>
  </mat-card>

  @if(!node().data.in_trash) {
  <a class="zoom-to-item" href="#/{{ node().data.id }}" (click)="zoomToThisItem()" matTooltip="Zoom to item">
    <mat-icon>height</mat-icon>
  </a>
  <mat-icon class="add-child" (click)="addChildItem()" matTooltip="Add subitem" matTooltipPosition="left">add</mat-icon>
  }
</div>